import { Icon } from '@gitbook/spine-icons';
import { Badge, type BadgeProps, Tooltip } from '@gitbook/spine-react';

/** A badge to indicate the installation status of an integration */
export function IntegrationInstallationStatusBadge(props: {
    isActive: boolean;
    iconOnly?: BadgeProps['iconOnly'];
}) {
    const { isActive, iconOnly = false } = props;

    return (
        <Tooltip
            label={
                isActive
                    ? 'Integration is installed and active'
                    : 'Finish configuring the integration to use it'
            }
        >
            <Badge
                iconOnly={iconOnly}
                kind={isActive ? 'success' : 'warning'}
                label={isActive && !iconOnly ? 'Installed' : 'Pending'}
                aria-label={
                    isActive && iconOnly
                        ? 'Integration is installed and active'
                        : 'Finish configuring the integration to use it'
                }
                icon={isActive ? Icon.Check : Icon.Warning}
            />
        </Tooltip>
    );
}
